import "reflect-metadata";
import { lazy } from "react";
import { injectable, registry } from "tsyringe";
import { FeatureSetupDef, FeatureRootRoute, FeatureSetup } from "@app/types/feature.types";

 import { version, name } from "@feature/package.json";
import { FeatureToken } from "@app/constants/di";
import { featurePaths } from "@feature/constants/paths.constant";

const ShowsListPage = lazy(() => import("@feature/pages/ShowsList"));
const CreateShowPage = lazy(() => import("@feature/pages/CreateShow"));
const UpdateShowPage = lazy(() => import("@feature/pages/UpdateShow"));

@injectable()
@registry([{ token: FeatureToken, useClass: ShowList }])
class ShowList implements FeatureSetupDef {
    GetFeatureSetup(): FeatureSetup {
        return {
            version,
            namespace: name,
            featuresRoot: this.features,
            permissions: [],
            index: true
        };
    }
    private readonly features: FeatureRootRoute = {
        requiredPermissions: [],
        children: [
            {
                title: "Show List",
                path: featurePaths.ShowList,
                page: ShowsListPage
            },
            {
                title: "Create Show",
                path: featurePaths.CreateShow,
                page: CreateShowPage
            },
            {
                title: "Update Show",
                path: featurePaths.EditShow,
                page: UpdateShowPage
            }
        ]
    };
}
